var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fluent:mail-20-filled"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.7 4.79206V9.42461C11.7 9.85559 11.5288 10.2689 11.2241 10.5737C10.9194 10.8784 10.506 11.0496 10.075 11.0496H2.92505C2.49407 11.0496 2.08075 10.8784 1.776 10.5737C1.47125 10.2689 1.30005 9.85559 1.30005 9.42461V4.79206L6.33495 7.75476C6.38497 7.78426 6.44198 7.79982 6.50005 7.79982C6.55812 7.79982 6.61513 7.78426 6.66515 7.75476L11.7 4.79206ZM10.075 2.59961C10.4749 2.59955 10.8607 2.7469 11.1587 3.01349C11.4567 3.28008 11.646 3.64718 11.6903 4.04456L6.50005 7.09761L1.3098 4.04456C1.3541 3.64718 1.54336 3.28008 1.84137 3.01349C2.13937 2.7469 2.5252 2.59955 2.92505 2.59961H10.075Z",
    fill: "#29406C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.72e0b7067a9664b4281427b0e41adffc.svg";
export { ForwardRef as ReactComponent };